import React from "react";
import { Box, Typography, Divider } from "@material-ui/core";
import { getLang } from "app/feature/constants";
import CreditBalanceReloadLogTable from "../../table/creditBalanceReloadLogTable";

export default function CreditReloadLogPanelComponent({
  lang,
  creditReloadLog,
  totalFiltered,
  isFetching,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  tableFilter,
  handleReload,
  paginationOptions,
  disbursementInfo,
}) {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>
        <Typography variant="body1">
          <b>{getLang(lang, "label.CREDIT_BALANCE_RELOAD_LOG")}</b>
        </Typography>
      </Box>
      <Box mt={1} mb={2}>
        <Divider />
      </Box>
      <CreditBalanceReloadLogTable
        rows={creditReloadLog}
        isFetching={isFetching}
        isError={isError}
        handleReload={handleReload}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        totalFiltered={totalFiltered}
        paginationOptions={paginationOptions}
        tableFilter={tableFilter}
        lang={lang}
        disbursementInfo={disbursementInfo}
      />
    </Box>
  );
}
